import { useState, useEffect } from "react";

/**
 * A custom React hook that runs an effect after the first mount of the component.
 * @param {Function} callback - The callback function to execute after the first mount.
 * @param {Array} dependencies - The dependencies array to watch for changes.
 */
const useEffectAfterMount = (callback, dependencies) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      callback();
    }
  }, dependencies);
};

export default useEffectAfterMount;
